/**
 * KFZ Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { AntragsfragenGruppiertMitBedingungen } from '@comparit/common-api';
import { VorgangDocument } from '@comparit/common-api';
import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { KfzSetAntragResponse } from '../model/kfz-set-antrag-response.model';
// @ts-ignore
import { VorgangResponse } from '@comparit/common-api';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    KfzWarenkorbServiceInterface,
    CreateKfzVorgangRequestParams,
    ExecuteKfzVorgangGetOrderRequestParams,
    GenerateKfzDeckungsnoteRequestParams,
    GetDocumentContentRequestParams,
    GetKfzVorgangRequestParams,
    GetKfzVorgangAntragsfragenRequestParams,
    GetKfzVorgangDocumentsRequestParams,
    SetKfzAntragRequestParams
} from './kfz-warenkorb.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class KfzWarenkorbService extends BaseService implements KfzWarenkorbServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Legt einen Vorgang ohne Preis und Dokumente des Versicherers an
     * Antwortet sofort mit getOrderStatus Unknown, Beträgen null und leerer Dokumentliste; der verbindliche Preis und die Versichererdokumente werden anschließend über ExecuteKfzVorgangGetOrder abgerufen.
     * @endpoint post /api/sparte-kfz/vorgang
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public createKfzVorgang(requestParameters: CreateKfzVorgangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public createKfzVorgang(requestParameters: CreateKfzVorgangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public createKfzVorgang(requestParameters: CreateKfzVorgangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public createKfzVorgang(requestParameters: CreateKfzVorgangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const createVorgangRequest = requestParameters?.createVorgangRequest;
        if (createVorgangRequest === null || createVorgangRequest === undefined) {
            throw new Error('Required parameter createVorgangRequest was null or undefined when calling createKfzVorgang.');
        }
        const kundeToken = requestParameters?.kundeToken;
        const session = requestParameters?.session;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createVorgangRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft Preis und Dokumente des Versicherers ab und persistiert sie am Vorgang
     * Führt den Abruf bei Unknown, Error oder verwaistem Loading in diesem Aufruf aus und antwortet erst mit dem Ergebnis. Liefert bei Success das persistierte Ergebnis und bei einem parallel laufenden Abruf den aktuellen Zustand ohne erneuten Anstoß. Ein fehlgeschlagener Abruf wird als getOrderStatus Error zurückgegeben und kann wiederholt werden.
     * @endpoint post /api/sparte-kfz/vorgang/{id}/get-order
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public executeKfzVorgangGetOrder(requestParameters: ExecuteKfzVorgangGetOrderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public executeKfzVorgangGetOrder(requestParameters: ExecuteKfzVorgangGetOrderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public executeKfzVorgangGetOrder(requestParameters: ExecuteKfzVorgangGetOrderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public executeKfzVorgangGetOrder(requestParameters: ExecuteKfzVorgangGetOrderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling executeKfzVorgangGetOrder.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/get-order`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Erzeugt die Deckungsnote aus den Antragsfragen und hängt sie an den Vorgang an
     * @endpoint post /api/sparte-kfz/vorgang/{id}/deckungsnote
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public generateKfzDeckungsnote(requestParameters: GenerateKfzDeckungsnoteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VorgangDocument>>;
    public generateKfzDeckungsnote(requestParameters: GenerateKfzDeckungsnoteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VorgangDocument>>>;
    public generateKfzDeckungsnote(requestParameters: GenerateKfzDeckungsnoteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VorgangDocument>>>;
    public generateKfzDeckungsnote(requestParameters: GenerateKfzDeckungsnoteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling generateKfzDeckungsnote.');
        }
        const generateDeckungsnoteRequest = requestParameters?.generateDeckungsnoteRequest;
        if (generateDeckungsnoteRequest === null || generateDeckungsnoteRequest === undefined) {
            throw new Error('Required parameter generateDeckungsnoteRequest was null or undefined when calling generateKfzDeckungsnote.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/deckungsnote`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VorgangDocument>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: generateDeckungsnoteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Inhalt eines Dokuments abrufen
     * @endpoint get /api/sparte-kfz/vorgang/documents/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public getDocumentContent(requestParameters: GetDocumentContentRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<object>;
    public getDocumentContent(requestParameters: GetDocumentContentRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<object>>;
    public getDocumentContent(requestParameters: GetDocumentContentRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<object>>;
    public getDocumentContent(requestParameters: GetDocumentContentRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDocumentContent.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/documents/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<object>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft einen Vorgang zur Fortsetzung ab
     * Beantwortet auch einen Vorgang, dessen Antrag gerade übermittelt wird oder bereits übermittelt wurde; status nennt den Stand, auch wenn die Antwort des Antragsversands nie ankam.
     * @endpoint get /api/sparte-kfz/vorgang/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public getKfzVorgang(requestParameters: GetKfzVorgangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public getKfzVorgang(requestParameters: GetKfzVorgangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public getKfzVorgang(requestParameters: GetKfzVorgangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public getKfzVorgang(requestParameters: GetKfzVorgangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getKfzVorgang.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft die Antragsfragen eines Vorgangs mit vorausgefüllten Antworten ab
     * Berechnung und Kombination werden aus dem Vorgang abgeleitet. Die Antworten werden aus dem Task-Entwurf bzw. den beim Erzeugen der Deckungsnote gespeicherten Antworten vorausgefüllt.
     * @endpoint get /api/sparte-kfz/vorgang/{id}/antragsfragen
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public getKfzVorgangAntragsfragen(requestParameters: GetKfzVorgangAntragsfragenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AntragsfragenGruppiertMitBedingungen>;
    public getKfzVorgangAntragsfragen(requestParameters: GetKfzVorgangAntragsfragenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AntragsfragenGruppiertMitBedingungen>>;
    public getKfzVorgangAntragsfragen(requestParameters: GetKfzVorgangAntragsfragenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AntragsfragenGruppiertMitBedingungen>>;
    public getKfzVorgangAntragsfragen(requestParameters: GetKfzVorgangAntragsfragenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getKfzVorgangAntragsfragen.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/antragsfragen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AntragsfragenGruppiertMitBedingungen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dokumente eines Vorgangs abrufen
     * @endpoint get /api/sparte-kfz/vorgang/{id}/documents
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public getKfzVorgangDocuments(requestParameters: GetKfzVorgangDocumentsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VorgangDocument>>;
    public getKfzVorgangDocuments(requestParameters: GetKfzVorgangDocumentsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VorgangDocument>>>;
    public getKfzVorgangDocuments(requestParameters: GetKfzVorgangDocumentsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VorgangDocument>>>;
    public getKfzVorgangDocuments(requestParameters: GetKfzVorgangDocumentsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getKfzVorgangDocuments.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/documents`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VorgangDocument>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Kfz-Antrag abschließen
     * @endpoint post /api/sparte-kfz/antrag-einreichen
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public setKfzAntrag(requestParameters: SetKfzAntragRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzSetAntragResponse>;
    public setKfzAntrag(requestParameters: SetKfzAntragRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzSetAntragResponse>>;
    public setKfzAntrag(requestParameters: SetKfzAntragRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzSetAntragResponse>>;
    public setKfzAntrag(requestParameters: SetKfzAntragRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const setAntragRequest = requestParameters?.setAntragRequest;
        if (setAntragRequest === null || setAntragRequest === undefined) {
            throw new Error('Required parameter setAntragRequest was null or undefined when calling setKfzAntrag.');
        }
        const kundeToken = requestParameters?.kundeToken;
        const session = requestParameters?.session;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/antrag-einreichen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzSetAntragResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: setAntragRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
